import { z } from "zod";

export const dataStateSchema = z.enum(["LIVE", "DERIVED", "PROXY", "UNAVAILABLE", "SYNTHETIC"]);
export type DataState = z.infer<typeof dataStateSchema>;

export const freshnessSchema = z.enum(["CURRENT", "STALE", "UNKNOWN"]);
export type Freshness = z.infer<typeof freshnessSchema>;

export const qualitySchema = z.enum(["VERIFIED", "PARTIAL", "ESTIMATED", "INSUFFICIENT"]);
export type Quality = z.infer<typeof qualitySchema>;

export const reconciliationSchema = z.enum(["PASSED", "EXCEPTION", "NOT_APPLICABLE", "UNKNOWN"]);
export type Reconciliation = z.infer<typeof reconciliationSchema>;

export const financialClassificationSchema = z.enum([
  "ACTUAL",
  "ACCRUED_RESERVED",
  "FORECAST",
  "ESTIMATED_EXPOSURE",
  "POTENTIAL_AVOIDED_EXPOSURE",
  "AWAITING_DATA",
]);
export type FinancialClassification = z.infer<typeof financialClassificationSchema>;
